import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { ExtensionService } from './extension.service';
import { AppService } from '../app.service';
import { RentingExtensionComponent } from '../shared/renting-extension/renting-extension.component';

@Injectable({
  providedIn: 'root'
})
export class ExtensionSmartService {

  constructor(private toastr: ToastrService,
              private extensionService: ExtensionService,
              private appService: AppService) { }

  /**
   * Prolonger la reservation
   * 
   * @param renting 
   */
  OpenModalExtension(renting: any) {

    this.extensionService.checkIfExtensionExist(renting.id).subscribe((response: any) => {

      if(response['exist'] == 1) {

        this.toastr.show(
            'Une prolongation a déja été enregistré pour cette location',
            'Erreur Erreur',
            {
              timeOut: 6000,
              closeButton: true,
            } as IndividualConfig,
            'toast-' + 'error'
        )

      } else {

        this.appService.openDialog(RentingExtensionComponent, renting, 'theme-dialog', '600px');

      }

    })

  }

}
